#version 300 es
    
precision highp float;
precision highp sampler3D;

in vec3 pass_textureCoordinates;

out vec4 color;

uniform vec2 windowLevel; //ww, wc
uniform vec3 colorMask;
uniform float alpha;
uniform int isPrimary;
uniform float checkerboardDensity;

uniform sampler3D sampler;

vec4 colorModification(float value, float alphaValue) {
    value = (value - windowLevel.y + (windowLevel.x * 0.5)) / windowLevel.x;
    value *= alphaValue;
    vec3 color = colorMask * value;
    return vec4(color, 1.0);
}

void main() {

    // Get window coordinates (pixels) from gl_FragCoord
    vec2 windowCoord = gl_FragCoord.xy;

    // Determine the checkerboard pattern based on texture coordinates
    vec2 texCoord = pass_textureCoordinates.xy;
    // Calculate checkerboard pattern based on window coordinates
    bool isChecker1 = 
        mod(floor(windowCoord.x / (240.0 * checkerboardDensity)), 2.0) == 
        mod(floor(windowCoord.y / (240.0 * checkerboardDensity)), 2.0);

    if (isPrimary == 0) {
        isChecker1 = !isChecker1;
    }

    float alphaValue = isChecker1 ? alpha : 0.0;

    // Sample from the texture and apply the alpha value
    float value = texture(sampler, pass_textureCoordinates).r;
    color = colorModification(value, alphaValue);
}